module.exports = __webpack_public_path__ + "img/58800.2bb061c8.jpg";